export const NAME = 'home';
const SET_ACADEMIC_YEAR_ID = `SET_ACADEMIC_YEAR_ID_${NAME}`;
const SET_CURRENT_CAMPUS_DATA = `SET_CURRENT_CAMPUS_DATA_${NAME}`;

export const setAcademicYearData = (data) => {
	return {
		type: SET_ACADEMIC_YEAR_ID,
		payload: data,
	};
};

export const setCurrentCampusData = (data) => {
	return {
		type: SET_CURRENT_CAMPUS_DATA,
		payload: data,
	};
};

const ACTION_MAP = {
	[SET_ACADEMIC_YEAR_ID]: (state, action) => {
		return {
			...state,
			selectedAcademicYear: action.payload,
		};
	},
	[SET_CURRENT_CAMPUS_DATA]: (state, action) => {
		return {
			...state,
			currentCampusData: action.payload,
		};
	},
};

const initialState = {
	selectedAcademicYear: null,
	selectedCurriculumProgram: null,
	currentCampusData: null,
};

export const reducer = (state = initialState, action) => {
	const actionFunc = ACTION_MAP[action.type];

	return actionFunc ? actionFunc(state, action) : state;
};
